import { render, staticRenderFns } from "./bookdetail.vue?vue&type=template&id=0b64dfb8&scoped=true&"
import script from "./bookdetail.vue?vue&type=script&lang=js&"
export * from "./bookdetail.vue?vue&type=script&lang=js&"
import style0 from "./bookdetail.vue?vue&type=style&index=0&id=0b64dfb8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b64dfb8",
  null
  
)

export default component.exports